import { render, staticRenderFns } from "./RateSalaryList.vue?vue&type=template&id=484ea649&scoped=true"
import script from "./RateSalaryList.vue?vue&type=script&lang=js"
export * from "./RateSalaryList.vue?vue&type=script&lang=js"
import style0 from "./RateSalaryList.vue?vue&type=style&index=0&id=484ea649&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484ea649",
  null
  
)

export default component.exports